import React, { useState, useContext, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useWindowSize } from 'react-use';
import { authPagesMenu } from '../../menu';
import Collapse from '../../components/bootstrap/Collapse';
import Icon from '../../components/icon/Icon';
import AuthContext from '../../contexts/authContext';
import ThemeContext from '../../contexts/themeContext';

const User = () => {
  const { width } = useWindowSize();
  const { setAsideStatus } = useContext(ThemeContext);
  const { userData, logout } = useContext(AuthContext);

  const navigate = useNavigate();

  const [collapseStatus, setCollapseStatus] = useState<boolean>(false);

  const { t } = useTranslation(['translation', 'menu']);

  return (
    <>
      <div
        className={classNames('user', { open: collapseStatus })}
        role='presentation'
        onClick={() => setCollapseStatus(!collapseStatus)}>
        <div className='user-info' style={{ marginLeft: '0.5rem' }}>
          <div className='user-name d-flex align-items-center'>
            {`${userData?.name} ${userData?.surname}`}
            <Icon icon='Verified' className='ms-1' color='info' />
          </div>
          <div className='user-sub-title'>{userData?.position}</div>
        </div>
      </div>
      {/* DropdownMenu removed - dark mode toggle disabled */}

      <Collapse isOpen={collapseStatus} className='user-menu'>
        <nav aria-label='aside-bottom-user-menu'>
          <div className='navigation'>
            <div
              role='presentation'
              className='navigation-item cursor-pointer'
              onClick={() => {
                // 使用 Okta logout
                if (logout) {
                  logout();
                }
                if (width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)) {
                  setAsideStatus(false);
                }
                navigate(`../${authPagesMenu.login.path}`);
              }}>
              <span className='navigation-link navigation-link-pill'>
                <span className='navigation-link-info'>
                  <Icon icon='Logout' className='navigation-icon' />
                  <span className='navigation-text'>{t('menu:Logout') as ReactNode}</span>
                </span>
              </span>
            </div>
          </div>
        </nav>
      </Collapse>
    </>
  );
};

export default User;
